<template>
  <div>
    <modal modal-id="add-cluster">
      <div slot="title">Add New Cluster Check</div>
      <div slot="form" class="row">
        <div class="col-lg-12 m-b-sm">
          <input type="text" class="form-control" v-model.trim="addCluster.name" placeholder="Name">
        </div>
        <div class="col-lg-12 m-b-sm">
          <input type="text" class="form-control" v-model.trim="addCluster.targetUrl" placeholder="Target Url">
        </div>
        <div class="col-lg-12 m-b-sm">
          <input type="text" class="form-control" v-model.trim="addCluster.keyword" placeholder="Main Keyword">
        </div>
        <div class="col-lg-12 m-b-sm">
          <v-select :options="locations" label="location_name" index="location_name" placeholder="Country" v-model="addCluster.location"></v-select>
        </div>
        <div class="col-lg-12 m-b-sm">
          <v-select :options="languages" label="language_name" index="language_name" placeholder="Language" v-model="addCluster.language"></v-select>
        </div>
        <div class="col-lg-12 m-b-sm">
          <textarea class="form-control" v-model="addCluster.keywords" placeholder="Supporting Keywords (max 50)" rows="4"></textarea>
        </div>
        <div class="col-lg-12">
          <button class="btn btn-xs btn-primary" @click="saveCluster"><i class="fa fa-save"></i> Save and run cluster check</button>
        </div>
      </div>
    </modal>
    <div class="row">
      <div class="col-lg-3">
        <button class="btn btn-primary btn-xs" data-toggle="modal" data-target="#add-cluster"><i class="fa fa-plus"></i> Add New Cluster Check</button>
        <table class="table table-hover table-striped">
          <tbody>
          <tr v-for="check in checks" :key="check.id">
            <td>
              <i class="fa fa-clock orange" v-if="check.status === 'added'"></i>
              <i class="fa fa-check green" v-if="check.status === 'completed'"></i>
              <a><i class="fa fa-refresh pull-right" @click="rerunCheck(check.id)" v-tooltip="'Run this cluster again'"></i></a>
              <small>{{ check.startTime | aTime('DD.MM. HH:mm') }}</small><br>
              <a @click="showCheck(check.id)">{{ check.payload.name }}</a><br>
              <small>{{ check.payload.location || '/' }} / {{ check.payload.language || '/' }}</small>
            <td>
              <span v-if="check.payload.score">{{ check.payload.score.percentage }}</span>
              <span v-else>/</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-9" v-if="selectedCheck">
        <table class="table table-hover table-bordered">
          <thead>
          <tr>
            <th>Url</th>
            <th>Keyword</th>
            <th>Location</th>
            <th>Language</th>
            <th>Score</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ selectedCheck.payload.url }}</td>
            <td>{{ selectedCheck.payload.keyword }}</td>
            <td>{{ selectedCheck.payload.location }}</td>
            <td>{{ selectedCheck.payload.language }}</td>
            <td>
              <span v-if="selectedCheck.payload.score" v-tooltip="selectedCheck.payload.score.score + '/' + selectedCheck.payload.score.max">
                {{ selectedCheck.payload.score.percentage }}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="5"><i>Keywords:</i> {{ selectedCheck.payload.keywords.join(', ') }}</td>
          </tr>
          </tbody>
        </table>
        <table class="table table-hover table-striped">
          <thead>
          <tr>
            <th>Keyword</th>
            <th>Indexed</th>
            <th>Url</th>
            <th>Anchor</th>
            <th v-tooltip="'Page Entity'">PE</th>
            <th>Score</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><b>{{ selectedCheck.payload.keyword }}</b></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-for="kw in selectedCheck.result.keywords" :key="kw.keyword">
            <td>{{ kw.keyword }}</td>
            <td>
              <i class="fa fa-check green" v-if="kw.exactIndexed"></i>
              <i class="fa fa-check orange" v-if="kw.partialIndexed"></i>
              <i class="fa fa-remove red" v-if="!kw.exactIndexed && !kw.partialIndexed"></i>
            </td>
            <td>
              <span v-if="kw.url">
                <span :class="kw.url === selectedCheck.payload.url ? 'green' : ''">{{ kw.url }} <a :href="kw.url" target="_blank"><i class="fa fa-external-link"></i></a></span>
              </span>
              <span v-else>/</span>
            <td>
              <span v-if="kw.link && kw.link.found">
                <span v-if="kw.link.found">
                  <i class="fa fa-check green"></i> ({{ kw.link.count }}) {{ kw.link.anchors.join(', ') }}
                </span>
              </span>
              <i class="fa fa-remove red" v-else></i>
            </td>
            <td>
              <span v-if="kw.url">
                <span v-if="kw.pageEntity">
                  <span v-if="kw.pageEntity === 'waiting'"><i class="fa fa-clock"></i></span>
                  <span v-else>{{ kw.pageEntity.score }}</span>
                  <a v-tooltip="'Refresh Page Entity Report'" @click="runPe(kw.url, kw.keyword)"><i class="fa fa-refresh"></i></a>
                </span>
                <span v-else>
                  /
                  <a v-tooltip="'Run Page Entity Report'" @click="runPe(kw.url, kw.keyword)"><i class="fa fa-download"></i></a>
                </span>
              </span>
            </td>
            <td>
              {{ kw.score.final }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Form from '../../../../Helpers/Modal/Form'
import axios from 'axios'
import { mapGetters } from 'vuex'
import locations from '../../../../../../static/countries.json'
import languages from '../../../../../../static/languages.json'

export default {
  data () {
    return {
      addCluster: {},
      checks: [],
      selectedCheck: false,
      languages: languages,
      locations: locations
    }
  },
  mounted () {
    this.loadClusters()
  },
  computed: {
    ...mapGetters({
      site: 'getPbn'
    })
  },
  watch: {
    site () {
      this.loadClusters()
      this.selectedCheck = false
    }
  },
  components: {
    modal: Form
  },
  methods: {
    saveCluster () {
      let data = this.addCluster
      axios.post(`/pbn/site/${this.site.punyDomain}/cluster`, data)
        .then(r => {
          this.$toastr.success('Cluster check successfully created')
          $('#add-cluster').modal('hide')
          this.addCluster = {}
          this.loadClusters()
        })
        .catch(e => {
          this.$toastr.error(`Cluster check creation failed`, e.response.data.msg)
        })
    },
    loadClusters () {
      axios.get(`/pbn/site/${this.site.punyDomain}/cluster-check/list`)
        .then(r => {
          this.checks = r.data.data
        })
    },
    showCheck (id) {
      axios.get(`/pbn/site/${this.site.punyDomain}/cluster-check/${id}`)
        .then(r => {
          this.selectedCheck = r.data
        })
    },
    runPe (url, keyword) {
      if (!confirm(`Run Page Entity for ${keyword}?`)) {
        return
      }
      axios.post(`/pbn/site/${this.site.punyDomain}/page-entity?force=1`, {
        url: url,
        keyword: keyword,
        location: this.selectedCheck.payload.location,
        language: this.selectedCheck.payload.language
      })
        .then(r => {
          this.selectedCheck = r.data.check
          this.$toastr.success('Triggered PE check')
        })
        .catch(e => {
          this.$toastr.error(e.response.data.error.msg, 'Something went wrong')
        })
    },
    rerunCheck (id) {
      if (!confirm('Run the same cluster check again?')) {
        return
      }
      axios.post(`/pbn/site/${this.site.punyDomain}/cluster-check/${id}/rerun`)
        .then(r => {
          this.loadClusters()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Cluster.vue